import { render, staticRenderFns } from "./SelectPayment.vue?vue&type=template&id=08be87a2&scoped=true&"
import script from "./SelectPayment.vue?vue&type=script&lang=js&"
export * from "./SelectPayment.vue?vue&type=script&lang=js&"
import style0 from "./SelectPayment.vue?vue&type=style&index=0&id=08be87a2&lang=scss&scoped=true&"
import style1 from "./SelectPayment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be87a2",
  null
  
)

export default component.exports